module.exports = __webpack_public_path__ + "static/media/mobile-step2-en.d143ee9c.png";